import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries.js';
import dayjs from 'dayjs'

import testSched_9Day_num1 from '../Components/Schedule/SevenNineDay/utils/test-data/test-data-nine.js';

const client = generateClient();

export async function getDetailedSchedule(startDate, endDate, resourceId, userId) {
  
  let detailedScheduleArray = await client.graphql(
    {
      query: queries.scheduleApIgetDetailedSchedules,
      variables: {
        startDate,
        endDate,
        resourceId,
        userId
      }
    }
  );

  let detailedScedules = detailedScheduleArray.data.scheduleAPIgetDetailedSchedules.detailedSchedule;

  let filteredDetailedSchedules = detailedScedules.filter((dayType) => {
    return dayjs.unix(dayType.timeStart).isBefore(dayjs(endDate, 'YYYYMMDD').endOf('day'));
  })

  // console.log(detailedScedules);
  // console.log(filteredDetailedSchedules);

  const detailedSchedule = {
    startDate,
    endDate,
    detailedSchedules: filteredDetailedSchedules
  };

  return detailedSchedule;
}
